// Regex to validate name inputs on
const nameRegex = /^[A-Za-z\'\s\.\,\-]+$/;

export default name => {
    return nameRegex.test(name);
};